if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"src_features_Chat_components_ChatSidebar_index_tsx-src_components_common_DataTable_hooks_Filt-5e331b": 1,
"src_features_DataIngestion_components_DocumentViewerModal_index_tsx": 1,
"src_features_Datasets_components_DatasetForm_index_tsx-src_components_DicomViewer_DicomViewer-a7502a": 1,
"src_pages_Administration_index_tsx-src_features_Feedback_components_styles_scss": 1,
"src_pages_Calculations_index_tsx": 1,
"src_pages_Chat_index_tsx-src_features_Cohort_components_CohortList_Styles_module_scss-src_fea-37a79f": 1,
"src_pages_Cohorts_CohortDetails_tsx-src_components_common_DataTable_hooks_FilterDropdownWithS-69c48a": 1,
"src_pages_Cohorts_Form_tsx-src_components_common_DataTable_hooks_FilterDropdownWithSearch_mod-90ea3e": 1,
"src_pages_Cohorts_index_tsx-src_components_common_DataTable_hooks_FilterDropdownWithSearch_mo-ad5c80": 1,
"src_pages_CpgRag_index_tsx": 1,
"src_pages_Dashboard_index_tsx-src_features_Dashboard_components_ChartCard_styles_module_scss--b1b874": 1,
"src_pages_DataIngestion_AdvancedIngestion_tsx-src_features_DataIngestion_components_AdvancedI-15c087": 1,
"src_pages_DataIngestion_TemplateManagement_tsx-src_features_DataIngestion_components_Advanced-91dcc4": 1,
"src_pages_DataIngestion_index_tsx": 1,
"src_pages_Datasets_index_tsx-src_components_common_DataTable_hooks_FilterDropdownWithInput_mo-51985f": 1,
"src_pages_DbExplorer_index_tsx-src_components_common_DataTable_hooks_FilterDropdownWithSearch-abad73": 1,
"src_pages_DeIdentification_index_tsx-src_components_DicomViewer_DicomViewer_module_scss-src_c-5829cf": 1,
"src_pages_Feedback_index_tsx-src_features_Feedback_components_styles_scss": 1,
"src_pages_McpDocs_index_ts": 1,
"src_pages_Patients_index_tsx-src_features_Dashboard_components_ChartCard_styles_module_scss-s-c4096d": 1,
"src_pages_SourceRegistry_index_tsx": 1,
"src_pages_TerminologyServer_index_tsx": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload